import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const recentMatchData = createAsyncThunk(
  "getrecentMatchData",
  async () => {
    try {
      var { data } = await axios.get(
        "https://api.cricway.live/api/v1/match/getAllRecentMatches/asjgs55463"
      );
      return data;
    } catch (err) {
      return err;
    }
  }
);

const recentMatchSlice = createSlice({
  name: "recent",
  initialState: {
    data: [],
    pending: false,
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(recentMatchData.pending, (state) => {
        state.pending = true;
      })
      .addCase(recentMatchData.fulfilled, (state, action) => {
        state.pending = false;
        state.data = action.payload;
        state.error = false;
      })
      .addCase(recentMatchData.rejected, (state, action) => {
        state.pending = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});

export default recentMatchSlice.reducer;
